import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Common Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './helper/ScrollToTop';

// Import All Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Pricing from "./pages/Pricing";

import Contact from "./pages/Contact";
import Login from "./pages/Login";

import Terms from './pages/Terms';
import Policy from './pages/Policy';
import Refund from './pages/Refund';
import Faq from './pages/FAQ';

// Restricted Pages
import Dashboard from "./pages/Dashboard";
import UserDetails from './pages/UserDetails';

// Auth Context
import { useAuth } from './context/AuthContext';

function AppContent() {
    // Access the user from Auth Context
    const { user } = useAuth();
    const location = useLocation();

    // Protected and Guest-only route components
    const ProtectedRoute = ({ children }) => { return user ? children : <Navigate to="/login" />; };
    const GuestOnlyRoute = ({ children }) => { return !user ? children : <Navigate to="/dashboard" />; };

    // Define routes where Footer should Not be displayed
    const noFooterRoutes = ['/dashboard'];
    const hideFooter = noFooterRoutes.includes(location.pathname);

    return (
        <>
            <ScrollToTop />
            <Header />
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Policy />} />
                <Route path="/refund" element={<Refund />} />
                <Route path="/faq" element={<Faq />} />

                {/* Guest-only Route */}
                <Route path="/login" element={<GuestOnlyRoute><Login /></GuestOnlyRoute>} />

                {/* Protected Routes */}
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/user/:userId" element={<ProtectedRoute><UserDetails /></ProtectedRoute>} />
            </Routes>
            {!hideFooter && <Footer />}
        </>
    );
}

export default function App() {
    return (
        <BrowserRouter basename="/">
            <AppContent />
        </BrowserRouter>
    );
}